import Questions from "../../questions/Questions";

function Faq() {
  return (
    <div>
      <Questions isAccount={true} />
    </div>
  );
}

export default Faq;
